import React from 'react'
import { Formik, ErrorMessage } from 'formik'
import { TextField } from '@duik/it'
import * as Yup from 'yup'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { updateMaterial } from '../Store/actions'

const UpdateMaterial = props => (
  <div style={{ paddingTop: '12px' }}>
    <Formik
      initialValues={{
        material: ''
      }}
      validationSchema={MaterialSchema}
      onSubmit={value => {
        props.handleRightButton()
        props.updateMaterial(props.checkedLoads, value, props.activeData)
      }}
      render={({ values, handleBlur, handleChange, handleSubmit, isValid }) => {
        return (
          <form onSubmit={handleSubmit}>
            <div style={{ padding: '0 16px' }}>
              <TextField
                name="material"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.material}
              />
              <ErrorMessage
                name="material"
                render={msg => (
                  <span
                    style={{
                      position: 'absolute',
                      color: '#E6492D',
                      fontSize: '0.75rem'
                    }}
                  >
                    {msg}
                  </span>
                )}
              />
            </div>
            <div
              style={{
                position: 'fixed',
                bottom: 0,
                left: 0,
                display: 'flex',
                justifyContent: 'space-between',
                width: '100%',
                zIndex: 1
              }}
            >
              <div
                style={{
                  margin: '0 8px 16px 8px',
                  display: 'flex',
                  justifyContent: 'space-between',
                  width: '100%'
                }}
              >
                <div style={{ width: '48%' }}>
                  <div
                    style={{
                      width: '100%',
                      height: '40px',
                      background: '#fff',
                      boxShadow: '0px 1px 3px #00000029',
                      borderRadius: '4px',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center'
                    }}
                    onClick={props.handleLeftButton}
                  >
                    <span style={{ color: '#1565D8' }}>Cancel</span>
                  </div>
                </div>
                <div style={{ width: '48%' }}>
                  <button
                    type="submit"
                    style={{
                      width: '100%',
                      height: '40px',
                      background: isValid
                        ? 'transparent linear-gradient(0deg, #1665D8 0%, #1F6FE5 99%, #1F6FE5 100%) 0% 0% no-repeat padding-box'
                        : '#FFF',
                      boxShadow: '0px 1px 3px #00000029',
                      borderRadius: '4px',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      border: 'none',
                      fontSize: '1rem',
                      color: isValid ? '#fff' : '#1565D8',
                      pointerEvents: isValid ? 'auto' : 'none'
                    }}
                  >
                    Finish
                  </button>
                </div>
              </div>
            </div>
          </form>
        )
      }}
    />
  </div>
)

const mapDispatchToProps = dispatch => bindActionCreators({ updateMaterial }, dispatch)

export default connect(null, mapDispatchToProps)(UpdateMaterial)

const MaterialSchema = Yup.object().shape({
  material: Yup.string().required('Please enter a material')
})
